import { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Products from './pages/Products'
import ProductDetail from './pages/ProductDetail'
import MissionVision from './pages/MissionVision'
import Events from './pages/Events'
import EventDetail from './pages/EventDetail'
import About from './pages/About'
import Login from './pages/Login'
import Splash from './components/Splash'

// Admin imports
import ProtectedRoute from './components/ProtectedRoute'
import AdminLayout from './components/admin/AdminLayout'
import Dashboard from './pages/admin/Dashboard'
import AdminProducts from './pages/admin/AdminProducts'
import ProductForm from './pages/admin/ProductForm'
import AdminEvents from './pages/admin/AdminEvents'
import EventForm from './pages/admin/EventForm'
import AdminContacts from './pages/admin/AdminContacts'
import AdminTeam from './pages/admin/AdminTeam'
import TeamForm from './pages/admin/TeamForm'
import ChangePassword from './pages/admin/ChangePassword'
import AdminUsers from './pages/admin/AdminUsers'
import UserForm from './pages/admin/UserForm'

function App() {
  const [showSplash, setShowSplash] = useState(true)

  return (
    <div className="min-h-screen bg-white">
      {showSplash && <Splash onDone={() => setShowSplash(false)} duration={1500} />}
      {!showSplash && (
        <>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<><Navbar /><Home /><Footer /></>} />
            <Route path="/products" element={<><Navbar /><Products /><Footer /></>} />
            <Route path="/products/:id" element={<><Navbar /><ProductDetail /><Footer /></>} />
            <Route path="/mission-vision" element={<><Navbar /><MissionVision /><Footer /></>} />
            <Route path="/events" element={<><Navbar /><Events /><Footer /></>} />
            <Route path="/events/:id" element={<><Navbar /><EventDetail /><Footer /></>} />
            <Route path="/about" element={<><Navbar /><About /><Footer /></>} />
            <Route path="/login" element={<Login />} />

            {/* Admin routes */}
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="products/new" element={<ProductForm />} />
              <Route path="products/:id/edit" element={<ProductForm />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="events/new" element={<EventForm />} />
              <Route path="events/:id/edit" element={<EventForm />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="team/new" element={<TeamForm />} />
              <Route path="team/:id/edit" element={<TeamForm />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="users/new" element={<UserForm />} />
              <Route path="users/:id/edit" element={<UserForm />} />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>
          </Routes>
        </>
      )}
    </div>
  )
}

export default App
